import React, { useState, useEffect } from 'react'
import { Box, Button, Divider, IconButton, Modal, Grid, TextField, InputAdornment, Typography } from '@mui/material';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useCardDetailContext } from '../../../CardDetailContext';
import { socialLinksSections, getIconAndLabel } from '../../../Utilities/SocialMediaMapping';
import axios from 'axios';
import AccordionItem from '../../../Utilities/AccordionItem';
import ModalNavItem from '../../../Utilities/ModalNavItem';
import SocialLinkItem from '../../../Utilities/SocialLinkItem';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as TickIcon } from "../../../../Assets/img/icons/tick-shape.svg";
import PreviewCard from '../PreviewCard';
import { useQuantityContext } from '../../../QuantityContext';
import useApi from '../../../Utilities/useAPI';
import SearchIcon from '@mui/icons-material/Search';
import QRCode from 'qrcode.react';
import { set } from 'lodash';

const SocialLinks = ({ handleSuccess, handleFailure }) => {

  const { cardDetails, SocialLinks, updateSocialLinks, deleteSocialLink, setSocialLinks, socialLinkShow, setSocialLinkShow } = useCardDetailContext();

  // console.log("CARD DETAILSSSSSS", cardDetails?.CardName);
  const { callApiFunction, loading, error } = useApi();

  // console.log("Social Links are", SocialLinks);
  const { setisNavigationBlocked } = useQuantityContext();

  const [SaveEnable, setSaveEnable] = useState(false);

  const [initialSocialLink, setInitialSocialLink] = useState({});

  useEffect(() => {
    setInitialSocialLink(SocialLinks);
  }, []);

  useEffect(() => {
    setSaveEnable(JSON.stringify(initialSocialLink) !== JSON.stringify(SocialLinks));
    setisNavigationBlocked(JSON.stringify(initialSocialLink) !== JSON.stringify(SocialLinks));
  }, [SocialLinks, initialSocialLink]);

  // const addSocialLink = (network) => {
  //   updateSocialLinks(network, { url: '', visible: false });
  //   // console.log("SocialLinks Context: ", SocialLinks);
  // } //* For plus icon in Modal items

  const handleInputChange = (network, key) => (event) => {
    updateSocialLinks(network, { [key]: event.target.value });
  }; //* for Update Button and while typing in the textfield

  const toggleVisibility = (network) => {
    const link = SocialLinks.links.find((link) => link.network === network);
    const isVisible = link.visible;
    updateSocialLinks(network, { visible: !isVisible });
  }; //* To toggle visibility of icons in Preview Card

  const [deleteDialog, setdeleteDialog] = useState(false);
  const [TempSocialNetwork, setTempSocialNetwork] = useState(null);
  const clearSocialLink = (network) => {
    // deleteSocialLink(network);
    setTempSocialNetwork(network); //used to delete later - Included as LightBox is Coming as Intermediate
    setdeleteDialog(true);
  }; //* To delete a link; removes the object from the context

  const [openModal, setOpenModal] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [newSocialLinkUrl, setNewSocialLinkUrl] = useState(' ');
  const [selectedLink, setSelectedLink] = useState({});
  const [selectedLinkTitle, setSelectedLinkTitle] = useState('');

  const [searchQuery, setSearchQuery] = useState('');

  const handleNewLinkChange = (event) => {
    const updatedUrl = event.target.value;
    setNewSocialLinkUrl(updatedUrl);

    if (selectedLink.network) {
      updateSocialLinks(selectedLink.network, { url: updatedUrl, visible: true });
    }
  }

  const handleUpdateLink = (network) => {

    // console.log("handleUpdateLink handleUpdateLink", network);
    if (newSocialLinkUrl.trim() !== "") {
      updateSocialLinks(network, { url: newSocialLinkUrl, visible: true });
      setOpenAddModal(false);
      setNewSocialLinkUrl(' ');
    }
  }

  const handleCancelLink = () => {
    setNewSocialLinkUrl('');

    if (selectedLink.network) { // for Temp View I have Added, When Cancelling Need to Remove
      deleteSocialLink(selectedLink.network);
    }
    setOpenAddModal(false);
    setOpenModal(true);
  };

  const handleAddMoreClick = () => {
    setOpenModal(true);
    setSearchQuery('');
  }

  const handleModalClose = () => {
    setOpenModal(false);
  }

  const handleAddLink = (network) => {
    // console.log("inSide the handleAddLink");
    const selected = socialLinksSections.flatMap(section => section.links).find(link => link.network === network);
    const selectedSection = socialLinksSections.find(section =>
      section.links.some(link => link.network === network) // Find the section that contains the link
    );
    const selectedTitle = selectedSection ? selectedSection.title : null;

    updateSocialLinks(network, { url: newSocialLinkUrl, visible: true }); //for Temporary View 
    setSelectedLink(selected);
    setSelectedLinkTitle(selectedTitle);
    setOpenAddModal(true);
    setOpenModal(false);
  }

  const handleAddModalClose = () => {
    setOpenAddModal(false);
  }

  const handleNavItemClick = (title) => {
    const sectionElement = document.getElementById(title);
    if (sectionElement) {
      sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const apiKey = process.env.REACT_APP_API_KEY
  const objectId = localStorage.getItem("objectId");
  const headers = {
    'Authorization': `Bearer ${objectId}`,
    'x-api-key': apiKey,
    'Content-Type': 'application/json'
  };


  const getNetworkId = (url) => {
    if (!url) return '';
    const parts = url.split('/');
    return parts[parts.length - 1]; // Get the last part of the URL
  };

  const handleSave = async (event) => {
    event.preventDefault();
    try {
      setSocialLinks((prev) => ({
        ...prev,
        card_type: cardDetails?.CardName,
      }));

      // console.log('Social  INside', SocialLinks);
      const response = await callApiFunction('socialLinkUpdate', SocialLinks);

      console.log('Response from backend:', response);

      if (response?.msg === "Card social links handled successfully") {
        setInitialSocialLink(SocialLinks);
        setSocialLinkShow(true);
        handleSuccess();
        try {
          const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/get-social-links`, {
            params: {
              cardType: cardDetails?.CardName,
            },
            headers: headers,
          });

          console.log("RESPONSE IN SOCIAL ", response);
          // setSocialLinkShow(response?.data)

          const transformedLinks = response.data.map((link) => ({
            network: link.info_key,
            url: link.info_value,
            visible: link.is_visible,
          }));

          // Remove duplicates based on the network property
          const uniqueLinks = transformedLinks.filter((link, index, self) =>
            index === self.findIndex((t) => t.network === link.network)
          );

          // Set the state with unique links
          setSocialLinkShow({
            user_ref_id: objectId,
            card_type: cardDetails?.CardName,
            links: uniqueLinks,
          });
          // console.log("")
        } catch (error) {
          console.log("API ERROR", error);
        }

      }

    } catch (error) {
      console.error('Error submitting card details:', error);
      handleFailure();
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };


  const filteredSocialLinksSections = socialLinksSections.map(section => ({
    ...section,
    links: section.links.filter(link =>
      link.network.toLowerCase().includes(searchQuery.toLowerCase())
    )
  })).filter(section => section.links.length > 0);

  return (
    <div>
      {/* <Box
        className="my-4 card-info-box"
        sx={{
          border: "1px solid #17b200",
          backgroundColor: "white",
          borderRadius: 2,
          paddingTop: "16px",
        }}
      > */}
      <div className="px-3">
        <div className="card-edit-info-heading" style={{ position: "relative" }}>
          <h5>Social Media Links</h5>
          <span>Add links to let people connect with you</span>
          <span className='span-center-align file-attach-icon-container' onClick={handleAddMoreClick}>
            <IconButton color="inherit">
              <AddCircleRoundedIcon />
            </IconButton>{" "} {SocialLinks?.links?.length > 0 ? "Add More" : "Add"}</span>
        </div>

        <div className="slideOpen-items-container mt-3">
          {/* <QRCode value='upi://pay?pa=ashishdash.1801@oksbi&pn=John+Doe&cu=INR' /> */}
          {/* <AccordionItem network={"linkedin"} icon={LinkedinIcon} url={SocialLinks.links.linkedin.url} visible={SocialLinks.linkedin.visible} toggleVisibility={toggleVisibility} onUpdate={handleInputChange} onDelete={clearSocialLink} defaultOpen={true} /> */}
          {SocialLinks?.links.map((link) => {
            const { icon: Icon, label } = getIconAndLabel(link.network);
            return (
              <AccordionItem
                key={link.network}
                network={link.network}
                icon={Icon}
                label={label}
                input={getNetworkId(link.url)}
                visible={link.visible}
                toggleVisibility={toggleVisibility}
                onUpdate={handleInputChange}
                onDelete={clearSocialLink}
                defaultOpen={link.network === 'linkedin'}
              />
            );
          })}

        </div>
      </div>
      <div className="save-bottom-container">
        <Button variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={handleSave} disabled={!SaveEnable}>
          Save
        </Button>
      </div>
      <ToastContainer toastClassName="email-toast-success" />

      <Modal open={openModal} onClose={handleModalClose}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "auto", bgcolor: 'background.paper', boxShadow: "0px 4px 4px 0px #00000040", borderRadius: 2, minWidth: "80%", maxHeight: "80%", overflowY: "scroll" }}>
          <div style={{ position: 'sticky', top: 0, backgroundColor: 'inherit', zIndex: 9 }}>
            <div className="px-3 pt-3">
              <div className="modal-heading">
                <h5>Social Media Links</h5>
                <span>Add links to let people connect with you</span>
                <span className='span-center-align file-attach-icon-container'>
                  <IconButton color="rgb(0, 0, 0, 0.54)" onClick={handleModalClose}>
                    <CloseRoundedIcon />
                  </IconButton></span>
              </div>


              {/* <TextField
                label="Search Social Links"
                value={searchQuery}
                onChange={handleSearchChange}
                fullWidth
                margin="normal"
              /> */}


              <div className='modal-nav d-flex flex-wrap my-2'>
                {filteredSocialLinksSections
                  .filter((section) => section.title !== 'Recommended')
                  .map((section, index) => (
                    <ModalNavItem key={index} title={section.title} filterFunction={() => handleNavItemClick(section.title)} />
                  ))}
              </div>
            </div>
            <Divider className='mb-3' sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }} />

            <div className="header-search-container">
              <TextField
                value={searchQuery}
                onChange={handleSearchChange}
                placeholder="Search"
                size="small"
                focused
                className="social-search-field px-3 mb-2"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <div className="icon">
                        <SearchIcon className="icon-color" />
                      </div>
                    </InputAdornment>
                  ),
                }}
                sx={{ width: "500px" }}
              />
            </div>
          </div>
          <div className="px-3" style={{ maxHeight: 'calc(80vh - 150px)' }}>
            {filteredSocialLinksSections.map((section, index) => (
              <section className='soc-modal-section mb-3' key={index} id={section.title}>
                <h5>{section.title}</h5>
                <Grid container spacing={2}>
                  {section.links.map((link, linkIndex) => (
                    <Grid item md={4} key={linkIndex}>
                      <SocialLinkItem icon={link.icon} label={link.label} network={link.network} contextState={SocialLinks} onAdd={handleAddLink} />
                    </Grid>
                  ))}
                </Grid>
              </section>
            ))}
          </div>
        </Box>
      </Modal>

      <Modal open={openAddModal} onClose={handleAddModalClose}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "auto", bgcolor: 'background.paper', boxShadow: "0px 4px 4px 0px #00000040", borderRadius: 2, paddingTop: 2, minWidth: "70%", maxHeight: "80%" }}>
          <div className="px-4 py-2">
            <div className="row g-0">
              <div className="col-md-6 col-lg-7 pe-4">
                <Box>
                  <div>
                    <h5 style={{ fontSize: "16px", fontWeight: "600", color: "rgb(0, 0, 0, 0.87)", marginBottom: "8px" }}> {selectedLink.label} </h5>
                    <span>Add Social Media Links to allow people to connect with you</span>
                  </div>
                  <div className='my-4'>
                    {selectedLink.icon && <selectedLink.icon className='svg-icon-3p5rem' />}
                  </div>
                  <TextField
                    label={selectedLinkTitle === "Payment" ? "Payment ID" : "Account Username"}
                    value={newSocialLinkUrl}
                    onChange={handleNewLinkChange}
                    fullWidth
                    autofocus
                  />
                  <div className='d-flex align-items-center justify-content-end mt-4'>
                    <Button className="secondary-btn" onClick={handleCancelLink}> Cancel </Button>
                    <Button variant="contained" className="primary-btn ms-3" onClick={() => handleUpdateLink(selectedLink.network)} sx={{ boxShadow: "none" }} disabled={newSocialLinkUrl.trim().length === 0}> Add </Button>
                  </div>
                </Box>
              </div>
              <div className="col-md-6 col-lg-5 ps-4" style={{ maxHeight: "400px", overflowY: "auto", scrollbarWidth: "none" }}>
                <PreviewCard isInsideModal={true} />
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      {deleteDialog &&
        <div className="lightbox-overlay">
          <div className="lightbox-content p-4">
            <div className='d-flex align-items-center justify-content-between'>
              {/* <h5 className='mb-0' style={{ fontSize: "18px", fontWeight: "bold", color: "black" }}> */}
              <Typography variant="h5" className="text-muted">
                Delete Social Link
              </Typography>
              <IconButton onClick={() => { setdeleteDialog(false); }}>
                <CloseRoundedIcon />
              </IconButton>
            </div>
            <Typography variant="body2" className="text-muted">Do you really want to delete this Social Link?</Typography>

            <div className='d-flex justify-content-end' style={{ marginTop: "24px" }}>
              <Button onClick={() => { setdeleteDialog(false) }} className="delete-button_configuration me-3" sx={{ color: "#0044C6" }}>
                CANCEL
              </Button>
              <Button className='delete-button_configuration' onClick={() => { deleteSocialLink(TempSocialNetwork); setdeleteDialog(false) }}>DELETE</Button>
            </div>
          </div>
        </div>
      }
      {/* </Box> */}
    </div>
  );
}

export default SocialLinks
